/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Archive': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10" cy="10" r="10" _fill="#243143" fill-opacity=".6"/><path pid="1" d="M7.55 12.8h-.495c-1.367 0-2.475-1.12-2.475-2.5a2.49 2.49 0 012.31-2.495A3.463 3.463 0 0110.026 5.8c1.745 0 3.189 1.304 3.43 3h.034a1.99 1.99 0 011.98 2c0 1.105-.886 2-1.98 2h-.99M8.469 10.564l1.555 1.458m0 0l1.556-1.458m-1.556 1.458V8.133" _stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
